import { MbeEdit, MbeTrashIcon } from '@/components/icons';
import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

interface ISettingCardProps {
  address?: {
    city: string;
    province: string;
    streetAddress: string;
    zipCode: string;
  };
  content?: string | undefined;
  index?: string;
  onDelete?: () => void;
  onOpen: (id: string | undefined) => void;
  title: string;
}

interface IEmptyAddressCardProps {
  onOpen: () => void;
}

export const SettingCard: React.FC<ISettingCardProps> = (props): JSX.Element => {
  const { content, onDelete, onOpen, title } = props;
  const { address, index } = props;

  return (
    <Flex
      alignItems="flex-start"
      border="2px"
      borderColor="gray.200"
      direction="column"
      height={32}
      justifyContent="center"
      position="relative"
      px={4}
      py={25}
      width={{ base: 'full', md: '32%' }}
    >
      <Text textTransform="uppercase">{title}</Text>
      {address ? (
        <Text fontWeight="bold">
          {address.streetAddress}
          <br />
          {address.zipCode} {address.city} {address.province}
        </Text>
      ) : (
        <Text fontWeight="bold">{content}</Text>
      )}
      <Flex position="absolute" px={4} py={25} right={0} top={0}>
        <Button
          rightIcon={<Icon as={MbeEdit} h={8} w={10} />}
          onClick={(): void => onOpen(index)}
        />
        {onDelete && (
          <Button
            rightIcon={<Icon as={MbeTrashIcon} h={8} w={10} />}
            onClick={(): void => onDelete()}
          />
        )}
      </Flex>
    </Flex>
  );
};

export const EmptyAddressCard: React.FC<IEmptyAddressCardProps> = (props): JSX.Element => {
  const { t } = useTranslation();

  const { onOpen } = props;

  return (
    <Flex
      alignItems="center"
      border={2}
      borderColor="brand.gray"
      borderStyle="dashed"
      gap={4}
      height={32}
      justifyContent="center"
      width={{ base: 'full', md: '32%' }}
    >
      <Button as="a" color="red" cursor="pointer" variant="text" onClick={onOpen}>
        {t('ACCOUNT.SETTINGS.ADD_NEW_ADDRESS')}
      </Button>
    </Flex>
  );
};
